/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef, useState, useEffect, useRef, useLayoutEffect  } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, ListItemIcon, ListItemText, Collapse, Button, colors,
  ListSubheader, 
 } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import DraftsIcon from '@material-ui/icons/Drafts';
import SendIcon from '@material-ui/icons/Send';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import StarBorder from '@material-ui/icons/StarBorder';

const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    //width: '200px',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: theme.palette.primary.main
    }
  },
  nested: {
    paddingLeft: theme.spacing(4),
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  nestedIcon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    //alignItems: 'center',
    marginRight: theme.spacing(1),
    justifyContent: 'flex-end'
  },
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div
    ref={ref}
    style={{ flexGrow: 1 }}
  >
    <RouterLink {...props} />
  </div>
));

const SidebarNav = props => {
  const { pages, className, ...rest } = props;

  const classes = useStyles();

  const [opens, setOpens] = useState([false, false, false, false, false, false, false, false]);
  //const [open, setOpen] = useState(false);

  const handleClick = (click_index) => {
    //setOpen(!open);
    //console.log(click_index);
    if (click_index < opens.length)
    {
      //console.log(click_index);
      let newOpens = [];
      opens.map((value, index) => {
        if (click_index == index) {
          newOpens.push(!value);
        }
        else {
          newOpens.push(false);
        }
      });
      setOpens(newOpens);
      //console.log(newOpens);
      //console.log(opens);
    }
  };

  //const firstUpdate = useRef(true);
  // useLayoutEffect(() => {
  //   if (firstUpdate.current) {
  //     firstUpdate.current = false;
  //     return;
  //   }

  //   console.log("componentDidUpdateFunction");
  // });

  // const startCheck = () => {
  //   if (firstUpdate.current) {
  //     firstUpdate.current = false;

  //     if (opens.length < 1)
  //     {
  //       console.log("initailize opens");
  //       let newOpens = new Array();
  //       for ( var i = 0 ; i < pages.length ; i++)
  //         newOpens[i] = false;
  //       setOpens(newOpens);
  //     }

  //     return;
  //   }

  //   console.log("startCheck");
  // }

  // useEffect(() => {
  //   console.log("componentDidMount");
  //   //document.addEventListener("mousemove", mouseMoveHandler);
  //   //socket.on('update-order', updateOrder);
  //   //if (opens.length < 1)
  //   // {
  //   //   console.log("initailize opens");
  //   //   let newOpens = new Array();
  //   //   for ( var i = 0 ; i < pages.length ; i++)
  //   //     newOpens[i] = pages[i].open;
  //   //   setOpens(newOpens);
  //   // }
  //   return () => {
  //     console.log("componentDidUnmount");
  //     //socket.removeListener('update-order', updateOrder);
  //     // props.clearGroupMenus();
  //     // props.clearMenus();
  //     //document.removeEventListener("mousemove", mouseMoveHandler);
  //   };
  // }, []); // empty-array means don't watch for any updates

  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
    >
      {pages.map((page, index) => (
          <div key={page.title+index}>
          <ListItem
            className={classes.item}
            disableGutters
            key={page.title}
            // button component="a" href={page.href}
            //button onclick={() => handleClick(index)}
          >
            <Button
              //onclick={() => handleClick(index)}
              activeClassName={classes.active}
              className={classes.button}
              component={CustomRouterLink}
              to={page.href}
              //onClick={() => { console.log('onClick'); }}
              onClick={() => handleClick(index)}
              startIcon={
                <div className={classes.icon}>{page.icon}</div>
              }
              endIcon={
                //<Icon>send</Icon>
                page.submenus != undefined && page.submenus != null ? 
                opens[index] ? (<div className={classes.nestedIcon}><ExpandLess /></div>) : (<div className={classes.nestedIcon}><ExpandMore /></div>)
                :
                  <div key={page.title+index+index}></div>
              }
            >
              
              {page.title}
            </Button>

            {/* <ListItemIcon>
              <div className={classes.icon}>{page.icon}</div>
            </ListItemIcon>
            <ListItemText primary={page.title} /> */}
          </ListItem>
          

          <Collapse in={opens[index]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {page.submenus != undefined && page.submenus != null ? 
                page.submenus.map(submenu => (
                  <ListItem 
                    className={classes.nested}
                    disableGutters
                    key={submenu.title}
                  >
                    <Button
                      activeClassName={classes.active}
                      className={classes.button}
                      component={CustomRouterLink}
                      to={submenu.href}
                    >
                      {/* <div className={classes.icon}>{page.icon}</div> */}
                      {submenu.title}
                    </Button>
                  </ListItem>
                )) 
                :
                <div></div>
              }

            </List>
          </Collapse>

          </div>
        ))}
    </List>

    // <List
    //   {...rest}
    //   //component="nav"
    //   //aria-labelledby="nested-list-subheader"
    //   // subheader={
    //   //   <ListSubheader component="div" id="nested-list-subheader">
    //   //     Nested List Items
    //   //   </ListSubheader>
    //   // }
    //   //className={classes.root}
    //   className={clsx(classes.root, className)}
    // >
    //   {/* {console.log(opens)} */}
    //   {pages.map((page, index) => (
    //     <div key={page.title+index}>
    //     <ListItem 
    //       key={page.title+index} 
    //       button onClick={() => handleClick(index)}
    //       component={CustomRouterLink}
    //       to={page.href}
    //       >
    //       <ListItemIcon>
    //         {page.icon}
    //       </ListItemIcon>
    //       <ListItemText primary={page.title} />
    //       {/* {console.log(opens[index])} */}
    //       {page.submenus != undefined && page.submenus != null ? 
    //           opens[index] ? <ExpandLess /> : <ExpandMore />
    //         :
    //           <div key={page.title+index+index}></div>
    //       }
    //     </ListItem>

    //     {page.submenus != undefined && page.submenus != null ? 
    //       <Collapse in={opens[index]} timeout="auto" unmountOnExit>
    //         <List component="div" disablePadding>
    //             {page.submenus.map(submenu => (
    //               <ListItem 
    //                 key={submenu.title+index} 
    //                 button onClick={() => {}}
    //                 className={classes.nested}
    //                 //component={CustomRouterLink}
    //                 //to={page.href+submenu.href}
    //               >
    //                 {/* <ListItemIcon>
    //                   <StarBorder />
    //                 </ListItemIcon> */}
    //                 <ListItemText primary={submenu.title} />
    //               </ListItem>
    //             ))}
    //         </List>
    //       </Collapse>
    //       :
    //       <div key={page.title+index+index+index}></div>
    //     }
    //     </div>
    //   ))}
    //   {/* <ListItem button>
    //     <ListItemIcon>
    //       <SendIcon />
    //     </ListItemIcon>
    //     <ListItemText primary="Sent mail" />
    //   </ListItem>
    //   <ListItem button>
    //     <ListItemIcon>
    //       <DraftsIcon />
    //     </ListItemIcon>
    //     <ListItemText primary="Drafts" />
    //   </ListItem>
    //   <ListItem button onClick={handleClick}>
    //     <ListItemIcon>
    //       <InboxIcon />
    //     </ListItemIcon>
    //     <ListItemText primary="Inbox" />
    //     {open ? <ExpandLess /> : <ExpandMore />}
    //   </ListItem>
    //   <Collapse in={open} timeout="auto" unmountOnExit>
    //     <List component="div" disablePadding>
    //       <ListItem button className={classes.nested}>
    //         <ListItemIcon>
    //           <StarBorder />
    //         </ListItemIcon>
    //         <ListItemText primary="Starred" />
    //       </ListItem>
    //     </List>
    //   </Collapse> */}
    // </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array.isRequired
};

export default SidebarNav;
